var map = {
	"./almonitextension.jpg": 54381,
	"./alohabrowser.png": 16622,
	"./beacon.jpg": 30042,
	"./brave.jpg": 93352,
	"./cloudflare.jpg": 99979,
	"./coinbasewalletextension.jpg": 89348,
	"./ethdns.jpg": 37777,
	"./ethlimo.jpg": 50601,
	"./ethlink.jpg": 50348,
	"./metamask.jpg": 71477,
	"./metamaskmobile.jpg": 58265,
	"./mises.png": 56779,
	"./onekey.png": 72386,
	"./opera.jpg": 114,
	"./puma.jpg": 88068,
	"./status.jpg": 8012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60194;